import axios from 'axios';
import { Auth } from 'aws-amplify';
import * as types from '@/store/types';

export const APIS = {
  SELF_SERVICE: {
    name: 'SELF_SERVICE',
    authRequired: true,
    ignoreErrors: false,
  },
  CAMPAIGN_MATCHES: {
    name: 'CAMPAIGN_MATCHES',
    authRequired: false,
    ignoreErrors: true,
  },
};
const createClient = (apiConfig) => {
  const baseURL = process.env[`VUE_APP_${apiConfig.name}_API`];
  const config = {
    baseURL,
    authRequired: apiConfig.authRequired,
    ignoreErrors: apiConfig.ignoreErrors,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  };
  const client = axios.create(config);
  if (config.authRequired) {
    client.interceptors.request.use(async (request) => {
      request.headers.Authorization = `${(await Auth.currentSession()).getIdToken().getJwtToken()}`;
      return request;
    });
  }
  if (!config.ignoreErrors) {
    client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error && error.config && error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
          return Promise.reject(error);
        }
        const errorProperty = 'message';
        const message = (error.response && error.response.data && error.response.data.message) ? error.response.data[errorProperty] : 'Oops! Something went wrong. Try again later.';

        // Lazily require the store to avoid a circular dependency at module-load time:
        // clients.js -> store -> account/store -> account/actions -> accountApi -> clients.js
        // eslint-disable-next-line global-require
        const store = require('@/store').default;
        store.commit(types.SET_GLOBAL_MESSAGE, {
          type: 'danger',
          message,
        });
        return Promise.reject(error);

      },
    );
  }
  return client;
};
export const clients = Object.keys(APIS)
  .map((apiName) => ({ [APIS[apiName].name]: createClient(APIS[apiName]) })).reduce(
    (acc, current) => ({ ...acc, ...current }),
  );
